import { createStore } from 'owa-satcheljs';
import type { HeaderViewState } from './schema/HeaderViewState';

var initialHeaderViewState: HeaderViewState = {
    activeCharm: null,
};

export const getStore: () => HeaderViewState = createStore<HeaderViewState>(
    'headerViewState',
    initialHeaderViewState
);
